// Deep-link route for one meter (/meter/:mid?pid&gtype&gid&gname&pname).
// The dashboard embeds the same MeterPanel inline — this page exists so
// notifications/emails/bookmarks can land directly on a meter.

import type { ReactElement } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../components/Icon';
import MeterPanel from '../components/MeterPanel';
import { StateCard } from '../components/ui';
import { useUser } from '../lib/user';
import { LEGACY_ZONE } from '../lib/zone';

export default function MeterDetailPage(): ReactElement {
  const { t } = useTranslation();
  const { mid = '' } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const pid = params.get('pid') ?? '';
  const gtype = params.get('gtype');
  const gid = params.get('gid');
  const group =
    (gtype === 'g' || gtype === 'c') && gid ? { type: gtype as 'g' | 'c', id: gid } : undefined;
  // Every group of a project carries the same project timezone.
  const { me } = useUser();
  const tz =
    me?.categories_and_groups.find((g) => g.project_pid === pid)?.project_timezone || LEGACY_ZONE;

  if (!mid || !pid) {
    return (
      <StateCard
        title={t('meter.errorMissing')}
        action={
          <Link className="btn" to="/">
            {t('meter.goBack')}
          </Link>
        }
      />
    );
  }

  return (
    <>
      <div className="page-head" style={{ marginBottom: 0 }}>
        <button
          className="icon-btn"
          data-tip={t('meter.goBack')}
          aria-label={t('meter.goBack')}
          onClick={() => navigate(-1)}
        >
          <Icon name="arrow-left" size={20} />
        </button>
      </div>
      <MeterPanel
        key={mid}
        mid={mid}
        pid={pid}
        group={group}
        gname={params.get('gname')}
        pname={params.get('pname')}
        tz={tz}
      />
    </>
  );
}
